import { Box } from "@aircall/tractor";
import styled, { css } from "@xstyled/styled-components";

import { SegmentProps } from "./PlayerSpeakerSegment.decl";

function getHighlightStyle({ isHighlighted }: SegmentProps) {
  if (isHighlighted) {
    return css`
      &: before {
        content: "";
        border: 1px solid;
        border-color: warning-500;
        // use transparentized color to not hide the segment bar
        background-color: rgb(254 228 168 / 50%);
        border-radius: full;
        height: 8px;
        width: 100%;
        padding: 0 1px;
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    `;
  }
}

export const Segment = styled(Box).attrs<SegmentProps>(({ width, left }) => ({
  style: {
    width: `${width}%`,
    left: `${left}%`,
  },
}))<SegmentProps>`
  top: 0;
  height: 100%;
  border-radius: 38px;
  position: absolute;
  cursor: pointer;
  ${getHighlightStyle};
`;
